
import { Wifi, WifiOff } from "lucide-react";

interface ChatConnectionStatusProps {
  isConnected: boolean;
}

export function ChatConnectionStatus({ isConnected }: ChatConnectionStatusProps) {
  return (
    <div className={`
      flex items-center justify-center h-6 w-6 rounded-full
      ${isConnected ? 'text-green-500' : 'text-red-500'}
    `}>
      {isConnected ? (
        <Wifi className="h-4 w-4" />
      ) : (
        <WifiOff className="h-4 w-4" />
      )}
    </div>
  );
}
